module.exports={
	"Form": "BidItemViewManifest",
	"Scope": "BidItem-View",
	"Descriptors":
	{
		"BidItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "BidItem-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "BidItem-View-Identity",
				"Group": "BidItem-View-Identity"
			}
		},
		"BidItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "BidItem-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.Quantity":
		{
			"Name": "Quantity",
			"Hash": "BidItem-View-Quantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "BidItem-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "BidItem-View-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "BidItem-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "BidItem-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "BidItem-View-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "BidItem-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDBidItem":
		{
			"Name": "IDBid Item",
			"Hash": "BidItem-View-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.GUIDBidItem":
		{
			"Name": "GUIDBid Item",
			"Hash": "BidItem-View-GUIDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "BidItem-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "BidItem-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "BidItem-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "BidItem-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "BidItem-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "BidItem-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "BidItem-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "BidItem-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "BidItem-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "BidItem-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
